// extracted by mini-css-extract-plugin
module.exports = {"container":"favorite_container__36itn","title":"favorite_title__ZoIvg","icons":"favorite_icons__LpKo2","active":"favorite_active___h_r9"};